import { View, Pressable, StyleSheet } from 'react-native';
import { Wrap, Box } from 'react-native-flex-layout';

import CustomText from '../CustomText';
import { useResponsiveStyles } from '../../hooks';
import { getTimeFilterOptions } from '../../util/analytics/constants';
import AppStyles from '../../AppStyles';


const TimeFilterChips = ({ activeFilter, onFilterChange, options }) => {
  const { screenWidth } = useResponsiveStyles();
  const items = options || getTimeFilterOptions();

  // Narrow screens get the option's own short form. Trimming a "Past " prefix
  // off the full label would only ever work in English.
  const getDisplayLabel = (option) => {
    if (typeof option === 'string') return option;
    return screenWidth >= 800 ? option.label : option.short || option.label;
  };

  return (
    <View style={styles.container}>
      <Wrap shouldWrapChildren="true" spacing={6} justify="center">
        {items.map((element, index) => (
          <Pressable
            key={index}
            onPress={() => onFilterChange(index)}
            style={({ pressed }) => [{ cursor: 'pointer' }, pressed && styles.pressed]}
          >
            {({ hovered, focused }) => (
              <Box
                style={[
                  activeFilter === index ? styles.chipSelected : styles.chip,
                  activeFilter !== index && (hovered || focused) && styles.chipHovered,
                ]}
              >
                <CustomText
                  font="medium"
                  size={screenWidth < 500 ? 11 : 12}
                  color={activeFilter === index ? '#000' : AppStyles.colorSet.textSecondary}
                >
                  {getDisplayLabel(element)}
                </CustomText>
              </Box>
            )}
          </Pressable>
        ))}
      </Wrap>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    paddingVertical: 4,
    paddingHorizontal: 4,
    alignItems: 'center',
  },
  // V3: Visual feedback on press
  pressed: {
    opacity: 0.7,
  },
  // V3: Compact pill chip styling
  chip: {
    backgroundColor: AppStyles.colorSet.cardBackground,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 20,
    borderColor: AppStyles.colorSet.inputBorder,
    borderWidth: 1.5,
    paddingVertical: 6,
    paddingHorizontal: 10,
  },
  chipSelected: {
    backgroundColor: AppStyles.colorSet.brandPrimary,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 20,
    borderColor: '#D4A000',
    borderWidth: 2,
    paddingVertical: 6,
    paddingHorizontal: 10,
  },
  // Web hover/focus feedback for the (unselected) time-range filter chips
  chipHovered: {
    borderColor: AppStyles.colorSet.brandPrimary,
    backgroundColor: 'rgba(255, 196, 81, 0.08)',
  },
});

export default TimeFilterChips;
